/* Salvona — Custom encapsulation: capsule builder that pre-fills the inquiry form */
(function(){
  var PLAT={
    salsphere:{n:'SalSphere®',c:'#2E6CC8'},
    hydrosal:{n:'HydroSal®',c:'#0AA3B5'},
    multisal:{n:'MultiSal®',c:'#7A5AF8'},
    salscent:{n:'SalScent®',c:'#F2795B'}
  };
  function platform(a){
    var act=a.active||'',job=a.trigger||'',fmt=a.format||'',goals=a.goals||[];
    if(/Balm/.test(fmt)) return 'multisal';
    if(goals.indexOf('Two ingredients, one system')>-1) return 'multisal';
    if(/Protect|moisture/.test(job)) return 'multisal';
    if(/Deposit/.test(job)) return 'salsphere';
    if(/surface/.test(job)) return 'hydrosal';
    if(/over time/.test(job)) return /Fragrance/.test(act)?'hydrosal':'salsphere';
    if(/Retinol|Vitamin C/.test(act)) return 'multisal';
    if(/Fragrance/.test(act)) return 'hydrosal';
    return 'salsphere';
  }
  function init(root){
    if(root.dataset.init) return; root.dataset.init='1';
    var b=root.querySelector('[data-svc2-builder]'); if(!b) return;
    var state={goals:[]},prev=b.querySelector('[data-svc2-preview]'),match=b.querySelector('[data-svc2-match]'),
        platEl=b.querySelector('[data-svc2-plat]'),use=b.querySelector('[data-svc2-use]');
    b.querySelectorAll('.svc2-chips button').forEach(function(x){x.setAttribute('aria-pressed','false');});
    function lab(v){var x=[].filter.call(b.querySelectorAll('.svc2-chips button'),function(n){return n.dataset.v===v;})[0];return x?x.textContent:v;}
    function render(){
      ['active','trigger','format'].forEach(function(k){var dd=b.querySelector('[data-k="'+k+'"]');dd.textContent=state[k]?lab(state[k]):'—';dd.classList.toggle('is-empty',!state[k]);});
      var g=b.querySelector('[data-k="goals"]');g.textContent=state.goals.length?state.goals.map(lab).join(', '):'—';g.classList.toggle('is-empty',!state.goals.length);
      var any=state.active||state.trigger||state.format||state.goals.length;
      var tb=b.querySelector('[data-group="trigger"] [aria-pressed="true"]');
      var p=any?PLAT[platform(state)]:null;
      prev.style.setProperty('--pc',tb?tb.dataset.c:(p?p.c:'#9DB9E6'));
      prev.style.setProperty('--pc2',p?p.c:'#9DB9E6');
      prev.classList.toggle('is-live',!!state.trigger);
      prev.classList.toggle('is-two',state.goals.indexOf('Two ingredients, one system')>-1);
      if(p){match.hidden=false;platEl.textContent=p.n;match.style.setProperty('--mc',p.c);}else{match.hidden=true;}
      use.disabled=!any;
    }
    b.querySelectorAll('.svc2-chips').forEach(function(grp){
      var k=grp.dataset.group,many=grp.dataset.mode==='many';
      grp.addEventListener('click',function(e){
        var btn=e.target.closest('button'); if(!btn) return;
        var v=btn.dataset.v,on=btn.getAttribute('aria-pressed')==='true';
        if(many){
          btn.setAttribute('aria-pressed',on?'false':'true');
          state.goals=on?state.goals.filter(function(x){return x!==v;}):state.goals.concat(v);
        }else{
          grp.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed','false');});
          if(!on){btn.setAttribute('aria-pressed','true');state[k]=v;}else{state[k]=null;}
        }
        render();
      });
    });
    use.addEventListener('click',function(){
      var form=root.querySelector('#svc2-contact'); if(!form) return;
      var vals={active:state.active,trigger:state.trigger,format:state.format,goals:state.goals.join(', ')};
      Object.keys(vals).forEach(function(k){var f=form.querySelector('[data-f="'+k+'"]');if(f&&vals[k]){f.value=vals[k];f.classList.add('is-filled');}});
      var notes=form.querySelector('[data-f="notes"]');
      if(notes&&!notes.value&&!match.hidden) notes.value='Brief builder suggestion: '+platEl.textContent+' as a starting platform.\n\n';
      var card=root.querySelector('.svc2-form-card');
      card.scrollIntoView({behavior:'smooth',block:'start'});
      setTimeout(function(){var n=form.querySelector('input[name="contact[name]"]');if(n)n.focus({preventScroll:true});},600);
    });
    render();
    var ok=root.querySelector('.svc2-success'); if(ok){ok.scrollIntoView({block:'center'});ok.focus({preventScroll:true});}
  }
  function boot(){document.querySelectorAll('.svc2').forEach(init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
